import {Button} from '../../../ui-components/Button/button';
import {
    CloseIcon,
    LockIconSmall,
    RemoveBgIcon,
    RotateLeft,
    RotateRight,
    SaveIcon,
} from '../../../ui-components/Iconpack';
import Tracker from '../../../lib/analytics/tracker';
import {EventNames} from '../../../lib/analytics/events';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import 'react-image-crop/src/ReactCrop.scss';

interface TransformationImageAreaProps {
    allowBackgroundRemoval: boolean;
    isBgRemoved: boolean;
    isBulkEdit?: boolean;
    backgroundRemoveActions: () => void;
    onRotate: (angle: number) => void;
    rotation: number;
    saveImage: () => void;
    handleCloseButton: () => void;
}

export default function TransformationHeaderArea({
    allowBackgroundRemoval,
    isBgRemoved,
    backgroundRemoveActions,
    rotation,
    onRotate,
    isBulkEdit,
    saveImage,
    handleCloseButton,
}: TransformationImageAreaProps) {
    const navigate = useNavigate();

    return (
        <div className={'ml-6 flex w-full items-center justify-between'}>
            <div className='my-5 flex gap-1 rounded-[0.5rem] bg-[#1D2939] px-1 md:gap-4 md:px-3'>
                <>
                    {!isBulkEdit && (
                        <div className='relative'>
                            <Button
                                variant='secondary'
                                size='sm'
                                className='relative border-transparent bg-[#1D2939] text-[12px] font-[500] text-[#D0D5DD] hover:bg-transparent md:text-[14px]'
                                icon
                                disabled={!allowBackgroundRemoval}
                                onClick={() => {
                                    if (isBgRemoved) {
                                        Tracker.trackEvent(EventNames.TRANSFORMATION_BACKGROUND_REMOVED);
                                    } else {
                                        Tracker.trackEvent(EventNames.TRANSFORMATION_BACKGROUND_RESTORED);
                                    }
                                    backgroundRemoveActions();
                                }}>
                                <RemoveBgIcon />
                                <span className={'flex md:hidden'}>{isBgRemoved ? 'BG Restore' : 'Remove BG'}</span>
                                <span className={'hidden md:flex'}>
                                    {isBgRemoved ? 'Restore Original Background' : 'Remove Background'}
                                </span>
                            </Button>
                            {!allowBackgroundRemoval && (
                                <Button
                                    className='absolute left-[50px] top-[-5px] h-[10px] w-[88px] gap-2 rounded-[33px] bg-gradient-to-r from-[#FFB800] to-[#FFF500] text-[9px] font-[700] text-[#000000]'
                                    onClick={() => navigate('/settings/plans')}>
                                    <LockIconSmall />
                                    Upgrade
                                </Button>
                            )}
                        </div>
                    )}
                </>
                <div
                    className={'flex cursor-pointer items-center justify-center py-4'}
                    onClick={() => {
                        if (rotation === 0) {
                            onRotate(270);
                        } else {
                            onRotate(rotation - 90);
                        }
                    }}>
                    <RotateLeft />
                    <span className='hidden px-1 pt-1 text-[12px] font-[500] text-[#D0D5DD] md:flex md:text-[14px]'>
                        Rotate left
                    </span>
                    <span className='flex px-1 pt-1 text-[12px] font-[500] text-[#D0D5DD] md:hidden md:text-[14px]'>
                        RL
                    </span>
                </div>
                <div
                    className={'flex cursor-pointer items-center justify-center'}
                    onClick={() => {
                        if (rotation === 270) {
                            onRotate(0);
                        } else {
                            onRotate(rotation + 90);
                        }
                    }}>
                    <span className='hidden px-1 pt-1 text-[12px] font-[500] text-[#D0D5DD] md:flex md:text-[14px]'>
                        Rotate Right
                    </span>
                    <span className='flex px-1 pl-1 pt-1 text-[12px] font-[500] text-[#D0D5DD] md:hidden md:text-[14px]'>
                        RR
                    </span>
                    <RotateRight />
                </div>
            </div>
            <div className='mr-6 flex'>
                <div className='flex items-center justify-between gap-2'>
                    <Button
                        className='text-[14px] font-[600] text-[#FFFFFF]'
                        variant='primary'
                        size='sm'
                        icon
                        onClick={saveImage}>
                        <SaveIcon />
                        Save Image
                    </Button>

                    <Button
                        className='mr-6 text-[14px] font-[600] text-[#262626]'
                        variant='secondary'
                        size='sm'
                        onClick={handleCloseButton}>
                        <CloseIcon />
                        Close
                    </Button>
                </div>
            </div>
        </div>
    );
}
